import { createSelector } from 'reselect';
import { defaultGetId } from "./helpers";
import { composeCurrentKeySelector, generateCurrentKey } from "./base.api";
var selectRootState = function selectRootState(state) {
  return state;
};

/**
 * Define selector as injectable
 * @param getId {(value: any) => PropertyKey}
 * @param KEY {PropertyKey} use null for automatically generated key
 * @returns {{ KEY: PropertyKey, getId: (value: any) => PropertyKey} & OutputSelector<unknown, *, (res1: unknown, res2: unknown) => *>}
 */
export function createInjectableSelector() {
  var getId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetId;
  var KEY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : generateCurrentKey();
  var currentSelector = createSelector([selectRootState, composeCurrentKeySelector(KEY)], function (state, injectable) {
    return typeof injectable === 'function' ? injectable(state) : injectable;
  });
  return Object.assign(currentSelector, {
    KEY: KEY,
    getId: getId
  });
}
export function createInjectableAction() {
  var KEY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateCurrentKey();
  var currentHandler = function currentHandler() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return function (dispatch, getState) {
      var state = getState();
      var handler = composeCurrentKeySelector(KEY)(state);
      return handler.apply(void 0, args);
    };
  };
  return Object.assign(currentHandler, {
    KEY: KEY
  });
}